<template>
  <div class="error_st">
    <div class="section full pb pt">
      <div class="inner">
        <img
          class="img_error er_ser"
          src="@/assets/images/error_service_img.png"
          alt=""
        />
        <div class="cont_wrap">
          <div class="an_a tit">
            <img
              class="img"
              src="@/assets/images/svg/svg_error_service.svg"
              alt="서비스 점검중"
            />
            <span class="an_t">{{ $t('views.maintenance.1408') }}</span>
          </div>
          <div class="service_txt">
            <p>
              <span class="month">07</span>월
              <span class="date">08</span>일(<span class="day">수</span>)
              <span class="bold"
                ><span class="time">0</span
                >{{ $t('views.maintenance.9977') }}</span
              >
            </p>
            <p>
              <span class="month">07</span>월
              <span class="date">09</span>일(<span class="day">목</span>)
              <span class="bold"
                ><span class="time">12</span
                >{{ $t('views.maintenance.6190') }}</span
              >
            </p>
          </div>
          <p class="txt">
            {{ $t('views.maintenance.2541') }}<br />{{
              $t('views.maintenance.2688')
            }}
          </p>
          <!--<div class="an_a txt">
				<img class="img" src="../include/images/svg/svg_error_service_message.svg" alt="서비스 개선을 위한 점검시간 동안 일부 서비스 이용이 제한되는 점 양해 부탁드립니다."/>
					<span class="an_t">{{ $t('views.maintenance.3735') }}</span>
				</div>-->

          <div class="btn_wrap">
            <div class="bdsi_f2">
              <router-link :to="{ name: 'store' }" class="box_btn dull"
                ><span class="an_t">{{
                  $t('views.maintenance.7897')
                }}</span></router-link
              >
            </div>
            <div class="bdsi_f2">
              <a class="box_btn" @click="$router.go(-1)"
                ><span class="an_t">{{ $t('views.maintenance.5864') }}</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer id="footer"></footer>
  </div>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>

<style lang="scss" scoped></style>
